/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Suggestion_5Inputs */

const en_us2_search_suggestion_5 = /** @type {(inputs: Search_Suggestion_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminder`)
};

const pt_br2_search_suggestion_5 = /** @type {(inputs: Search_Suggestion_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembrete`)
};

const es_419_search_suggestion_5 = /** @type {(inputs: Search_Suggestion_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordatorio`)
};

const pt_pt2_search_suggestion_5 = /** @type {(inputs: Search_Suggestion_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembrete`)
};

const fr_fr2_search_suggestion_5 = /** @type {(inputs: Search_Suggestion_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rappel`)
};

const de_de2_search_suggestion_5 = /** @type {(inputs: Search_Suggestion_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erinnerung`)
};

const it_it2_search_suggestion_5 = /** @type {(inputs: Search_Suggestion_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promemoria`)
};

/**
* | output |
* | --- |
* | "Reminder" |
*
* @param {Search_Suggestion_5Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_suggestion_5 = /** @type {((inputs?: Search_Suggestion_5Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Suggestion_5Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_suggestion_5(inputs)
	if (locale === "es-419") return es_419_search_suggestion_5(inputs)
	if (locale === "pt-PT") return pt_pt2_search_suggestion_5(inputs)
	if (locale === "fr-FR") return fr_fr2_search_suggestion_5(inputs)
	if (locale === "de-DE") return de_de2_search_suggestion_5(inputs)
	if (locale === "it-IT") return it_it2_search_suggestion_5(inputs)
	return en_us2_search_suggestion_5(inputs)
});
export { search_suggestion_5 as "search.suggestion_5" }